import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import ReportItem from './ReportItem';

interface Report {
  id: string;
  fileName: string;
  fullPath: string;
  fileExtension: string;
  type: 'INPUT' | 'OUTPUT';
  status: string;
  date: string;
  senderName: string;
  fileType: string; // EMPFED/FEDBKA for INPUT files
  processed: boolean;
  createdAt: string;
  updatedAt: string;
  executionDate?: string;
  // Fields for compatibility
  lastModified: string;
  fileSize: number;
  eTag: string;
  storageClass: string;
}

interface Folder {
  folderName: string;
  fullPath: string;
  type: string;
  fileCount?: number;
}

interface ReportsListProps {
  reports: Report[];
  folders: Folder[];
}

const ReportsList: React.FC<ReportsListProps> = ({ reports, folders }) => {
  return (
    <Box sx={{ direction: 'rtl' }}>
      <TableContainer
        component={Paper}
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflowY: 'auto',
        }}
      >
        <Table
          stickyHeader
          sx={{
            backgroundColor: 'transparent',
            borderCollapse: 'separate',
            borderSpacing: '0 10px',
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: 'transparent' }}>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  שם קובץ
                </Typography>
              </TableCell>

              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סוג
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  תאריך
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  שם מעסיק
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  פעולות
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Display folders */}
            {folders.map((folder: Folder, index: number) => (
              <React.Fragment key={`folder-${index}`}>
                <ReportItem item={folder} type="folder" />
              </React.Fragment>
            ))}
            
            {/* Display files */}
            {reports.map((report: Report, index: number) => (
              <React.Fragment key={`file-${index}`}>
                <ReportItem item={report} type="file" />
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ReportsList; 